import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <footer className='footer'>
      Made with ❤️ by Muskan Mandil
    </footer>
  )
}

export default Footer;